import { render, staticRenderFns } from "./LeaveTypeAddEditModal.vue?vue&type=template&id=172f88f1"
import script from "./LeaveTypeAddEditModal.vue?vue&type=script&lang=js"
export * from "./LeaveTypeAddEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports